import { useMemo } from 'react'
import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyModel } from '@root/entities/currency'
import type BigNumber from 'bignumber.js'

type Props = {
  balanceCurrency: BigNumber
  balanceUsd: BigNumber
  currency: CurrencyModel
}

export const NodeBalanceOutlet: React.FC<Props> = ({
  balanceCurrency,
  balanceUsd,
  currency,
}) => {
  const ticketTruncated = useMemo(() => {
    return currency.ticker.length > 4
      ? `${currency.ticker.slice(0, 4)}…`
      : currency.ticker
  }, [currency.ticker])
  return (
    <Root>
      <CurrencyIcon withGoogleLens={false} currency={currency} size={20} />
      <Balances>
        <BalanceCurrency>
          <AmountFormatted
            amount={balanceCurrency}
            roundingMode="trunc"
            currency={ticketTruncated}
          />
        </BalanceCurrency>
        <BalanceUsd>
          <AmountFormatted
            amount={balanceUsd}
            roundingMode="trunc"
            currency="$"
          />
        </BalanceUsd>
      </Balances>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 5px;
  padding-inline: 8px 6px;

  border-radius: 6px;
  background: var(--appearanceA-3, var(--appearanceA-3));
  height: 36px;
  overflow: hidden;
`

const BalanceCurrency = styled.div`
  color: var(--text-11);

  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`

const BalanceUsd = styled.div`
  color: var(--text-7);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`

const Balances = styled.div``
